import restApiDispatcher from "@/store/utils/api-dispatcher";
import { AthleteEvent } from "@/models";

const getAthleteEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: AthleteEvent,
    action: "index",
    loadingKey: "athleteEventsLoading",
    storeKey: "athleteListEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getAthleteEvent = (context, params) => {
  restApiDispatcher(context, {
    resource: AthleteEvent,
    action: "show",
    commitType: "wrappedShow2",
    storeKey: "athleteEvent",
    loadingKey: "athleteEventLoading",
    params
  });
};

const createAthleteEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: AthleteEvent,
    storeKey: "athleteListEvents",
    loadingKey: "athleteEventsLoading",
    action: "create",
    commitType: "addToList",
    message: "Event Added Successfully.",
    params
  });

const updateAthleteEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: AthleteEvent,
    storeKey: "athleteListEvents",
    loadingKey: "athleteEventsLoading",
    action: "update",
    commitType: "edit",
    message: "Event Updated Successfully.",
    params
  });

const deleteAthleteEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: AthleteEvent,
    storeKey: "athleteEvent",
    loadingKey: "athleteEventsLoading",
    action: "delete",
    commitType: "show",
    message: "Event successfully deleted.",
    params
  });

const updateImageForEvent = (context, params) =>
  restApiDispatcher(context, {
    resource: AthleteEvent,
    storeKey: "athleteListEvents",
    loadingKey: "athleteEventsLoading",
    action: "imageUpdate",
    commitType: "editImage",
    params
  });

export default {
  getAthleteEventsList,
  getAthleteEvent,
  createAthleteEventsList,
  updateAthleteEventsList,
  deleteAthleteEventsList,
  updateImageForEvent
};
